import { empty as observableEmpty, Observable, Subscription } from 'rxjs';

import { catchError } from 'rxjs/operators';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { AppState, CURRENT_CONTRACT, NO_SCROLL } from '../../../app';

import { Store } from '@ngrx/store';

import { ContractsService } from './../../../core/services/contracts.service';
@Component({
  selector: 'hb-contracts-search',
  templateUrl: './contractsSearch.component.html',
  styleUrls: ['./contractsSearch.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContractsSearchComponent implements OnChanges, OnInit, OnDestroy {
  @Input() isInternalUser = false;
  @Input() initContract: string;

  searchLength = 3;

  contract = '';
  isActive = false;
  haveResults = false;

  resultsSubscription: Subscription;

  contractsList: any = [];
  hadString = false;
  currentContract: string;

  typingTimer: any;

  constructor(
    private store: Store<AppState>,
    private contractsService: ContractsService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const { isInternalUser, initContract } = changes;

    if (isInternalUser !== undefined) {
      this.searchLength = isInternalUser ? 4 : 1;
    }

    if (initContract.currentValue !== undefined) {
      this.currentContract =
        initContract.currentValue.contractID !== undefined
          ? initContract.currentValue.contractID
          : '';
    }
  }

  ngOnDestroy() {}

  ngOnInit() {}

  close(resetSearch: boolean = false) {
    if (resetSearch) {
      this.contract = '';
    }
    this.isActive = false;
    this.haveResults = false;
    this.noScroll();
  }

  searchContract($event: any) {
    const DELAY_TIME = 500;

    if (this.contract.length >= this.searchLength) {
      this.isActive = true;
    } else {
      this.isActive = false;
      return;
    }

    clearTimeout(this.typingTimer);

    this.typingTimer = setTimeout(() => {
      this._searchContract($event);
    }, DELAY_TIME);
  }

  _searchContract($event: any) {
    if (this.hadString) {
      this.hadString = false;
      this.contract = this.contract.substring(0, this.contract.length - 1);
    }
    this.contractsService
      .searchContract(this.contract)
      .pipe(
        catchError((error: any) => {
          return observableEmpty();
        }),
      )
      .subscribe((value: any) => {
        if (value.ErrorCode !== undefined) {
          return;
        } else {
          if (value.length > 0) {
            this.haveResults = true;
          }
          this.contractsList = value;
        }
      });
  }
  restoreSearch() {
    this.contract = '';
    this.isActive = false;
    this.haveResults = false;
    this.contractsList = [];
    this.noScroll();
  }

  setSearchResults(viewResults: boolean) {
    if (this.contractsList.length > 0) {
      this.haveResults = viewResults;
      this.noScroll();
    }
  }

  selectContract(id: any) {
    id = id.trim();
    this.contractsService.getContractInfo(id).subscribe(
      () => {
        this.currentContract = id;
        this.close(true);
      },
      () => {
        // Do nothing, just catch error
      },
    );
  }

  navDown(event: any) {
    const code = event.keyCode;
    const source = event.srcElement;

    let contractId: string;

    if (code === 13) {
      if (source.classList.contains('option')) {
        contractId = event.currentTarget.dataset.contractid;

        this.selectContract(contractId);
      }
    }

    if (code === 40) {
      if (source.classList.contains('search-input')) {
        // input
        source.parentElement.parentElement.querySelector('.option').focus();
      } else if (source.classList.contains('option')) {
        // option
        if (source.nextElementSibling === null) {
          return;
        }
        source.nextElementSibling.focus();
      }
    } else if (code === 38) {
      // up
      if (source.classList.contains('option')) {
        if (source.previousElementSibling === null) {
          return;
        }
        source.previousElementSibling.focus();
      }
    }
  }

  private noScroll() {
    const block = this.haveResults;

    this.store.dispatch({
      type: NO_SCROLL,
      payload: { block, source: 'ContractsSearchComponent' },
    });
  }
}
